export default __webpack_public_path__ + "static/media/7.ba5616ec.jpg";